import CookieBot from 'react-cookiebot'

import { environment } from './config/environment'

export const Cookiebot = () => {
  if (['local', 'development'].includes(environment.env) || environment.cypress) return null
  return <CookieBot domainGroupId={environment.cookiebot.id} />
}
